import { mdarsUserManualUrl } from '../../constants'
import { systemRequirementsUrl } from '../../constants'
import { mdarsDownloadInstructionsUrl } from '../../constants'
{/*import classNames from 'classnames'
import { Button } from '../uiLib'*/}

const MDARSSoftwareValidSubscription = ({ t, i18n }) => (
  <div className="content">
    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-subtitle')}</h4>
    <div className="m-b-md">
      {/*<form action="https://mazda.mobile.grade-x.com" target="_blank">
      <Button
        outlined
        className={classNames({
          'is-default': true
        })}
        btType="default"        
      >
        {t('common:open-mdars')}
      </Button>
      </form>      */}
    </div>
    <div className="m-b-md">
      <ul>
        <li>
          <a href={mdarsDownloadInstructionsUrl(i18n.language)}
            target="_blank">
            {t('common:click-here')}
          </a> {t('common:mdars-page-content-6')}
        </li>
        <li>
          {t('common:ids-page-content-21')}&nbsp;
          <a href={mdarsUserManualUrl(i18n.language)}
            target="_blank">
            {t('common:here')}
          </a>
        </li>
      </ul>
    </div>
    <div className="m-b-md">
      {t('common:ids-page-content-8')}&nbsp;
      <a href={systemRequirementsUrl(i18n.language)}
        target="_blank">
        {t('common:click-here')}
      </a>
    </div>
    <div className="m-b-md">
      <ul>
        <li>{t('common:mdars-page-content-15')}   
          <a href="https://mazda.mobile.grade-x.com"
            target="_blank">
            https://mazda.mobile.grade-x.com
          </a>{t('common:mdars-page-content-19')}
        </li>
      </ul>
    </div>
    <div className="m-b-md">
      {t('common:mdars-page-content-7')}
      <div className="columns">
        <div className="column is-4">
      <ul>
            <li>{t('common:mdars-page-content-23')}</li>
            <li>{t('common:mdars-page-content-22')}</li>
            <li>{t('common:mdars-page-content-24')}</li>
            <li>{t('common:mdars-page-content-36')}</li>
          </ul>
        </div>
        <div className="column is-4">
          <ul>
            <li>{t('common:mdars-page-content-21')}</li>
            <li>{t('common:mdars-page-content-20')}</li>
            <li>{t('common:mdars-page-content-18')}</li>
            <li>{t('common:mdars-page-content-37')}</li>
          </ul>
        </div>
        <div className="column is-4">
          <ul>
            <li>{t('common:mdars-page-content-17')}</li>
            <li>{t('common:mdars-page-content-9')}</li>
            <li>{t('common:mdars-page-content-8')}</li>
            <li>{t('common:mdars-page-content-38')}</li>
      </ul>
        </div>
      </div>
      <div>{t('common:mdars-page-content-2')}</div>
      <ul>
        <li>{t('common:mdars-page-content-10')}</li>
      </ul>
      <div>{t('common:mdars-page-content-16')} <a href="https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/VCM_firmware.zip" target="_blank">{t('common:click-here')}</a> {t('common:mdars-page-content-35')}</div>
    </div>
  </div>
)

export default MDARSSoftwareValidSubscription



// WEBPACK FOOTER //
// ./components/MDARSSoftware/WithValidSubscription.js